module.exports = __webpack_public_path__ + "static/media/savedJobsBack.5a98f84a.svg";